export const CaretDownUp = ({ size = 20 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.3081 17.9419C13.5522 18.186 13.9478 18.186 14.1919 17.9419C14.436 17.6978 14.436 17.3022 14.1919 17.0581L10.4419 13.3081C10.1978 13.064 9.80218 13.064 9.5581 13.3081L5.8081 17.0581L5.76538 17.1057C5.56516 17.3512 5.57928 17.7131 5.8081 17.9419C6.03693 18.1707 6.3988 18.1849 6.64429 17.9846L6.69189 17.9419L10 14.6338L13.3081 17.9419Z"
        fill="currentColor"
      />
      <path
        d="M9.60571 6.73463C9.85119 6.93485 10.2131 6.92073 10.4419 6.69191L14.1919 2.94191L14.2346 2.8943C14.4348 2.64882 14.4207 2.28694 14.1919 2.05812C13.9631 1.8293 13.6012 1.81518 13.3557 2.01539L13.3081 2.05812L10 5.36622L6.69189 2.05812C6.44782 1.81404 6.05218 1.81404 5.8081 2.05812C5.56403 2.3022 5.56403 2.69783 5.8081 2.94191L9.5581 6.69191L9.60571 6.73463Z"
        fill="currentColor"
      />
    </svg>
  );
};
